// import type { MetricPeriod } from '@packages/database/types';

import { MetricPeriod } from '@/api/metricService';

export const metricKeys = {
  all: (orgId: string) => ['metrics', orgId] as const,
  dashboard: (orgId: string, period: MetricPeriod, projectId?: string) =>
    [
      ...metricKeys.all(orgId),
      'dashboard',
      period,
      projectId ?? 'all',
    ] as const,
} as const;
